<a href="#" style="z-index: 10000;" *ngIf="geoLocatorLabel" (click)="openGeoLocator($event)" tabindex="1" class="tertiary-cta">
  <img width="13" height="14" src="/~/media/images/autonation/navigationmenu/mycurrentlocation.svg">
  {{geoLocatorLabel}}
</a>
